var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.imageProps)?_c('img',_vm._b({class:`${_vm.$attrs.class || 'responsive-image'} transition-image ${
    _setup.isLoaded ? 'loaded' : ''
  }`,attrs:{"alt":_vm.alt || '',"loading":_vm.lazy === false ? undefined : _vm.lazy},on:{"load":function($event){_setup.isLoaded = true}}},'img',_setup.imageProps,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }